export default __webpack_public_path__ + "static/media/016-bowl.30a89314.svg";